import { BaseEntity } from '../../models';
import { unidadeNegocioAtiva } from './unidade-negocio-situacao';
import { unidadeNegocioReferenciaQuantidadeQuantidade } from './unidade-negocio-referencia-quantidade';
import { ItemUnidade } from '../item-unidade';
import { UnidadeNegocioLinhaProducao } from './linha-producao/unidade-negocio-linha-producao';
import { UsuarioUnidadeNegocio } from '../usuario';
import { UnidadeNegocioNaturezaVenda } from './natureza-venda/unidade-negocio-natureza-venda';
import { UnidadeNegocioMercado } from './mercado/unidade-negocio-mercado';

export class UnidadeNegocio implements BaseEntity {
    id: number;
    idEmpresa: number;
    tipo: number;
    codigo: number;
    nome: string;
    situacao: number;
    /** Tipo de lançamento realizado pela unidade de negócio */
    lancamento: number;
    referenciaQuantidade: number; // Referência da quantidade para metas e projeções de vendas
    idItemUnidade: number;
    unidade: ItemUnidade;
    linhasProducao: UnidadeNegocioLinhaProducao[];
    possuiLinhasProducao: boolean;
    mercados: UnidadeNegocioMercado[];
    naturezasVendas: UnidadeNegocioNaturezaVenda[];
    usuarios: UsuarioUnidadeNegocio[];

    /** Configurações */
    // Pedidos
    /** Se a unidade de negócio deve habilitar a possibilidade de informar os comprimentos dos itens nos pedidos e cotações */
    habilitarComprimentosItensPedidos: boolean;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    constructor() {
        this.situacao = unidadeNegocioAtiva.id;
        this.referenciaQuantidade = unidadeNegocioReferenciaQuantidadeQuantidade.id;
        this.linhasProducao = [];
        this.mercados = [];
        this.naturezasVendas = [];
        this.usuarios = [];
    }
}
